import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const LeftMenu = ({
  sectionList,
  visibleSection,
  seoName,
  drugSectionList,
  isFromDosage,
  dosageGuideSlug,
  whatIsIndex
}) => {
  let value = '';
  const handleScrollNew = (e, elementId, isFocus) => {
    e.preventDefault();
    if (typeof window !== 'undefined') {
      window.history.pushState(
        {},
        `what-is${elementId}`,
        `${window.location.pathname}#${elementId}`
      );
    }
    document
      .getElementById(elementId)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
    isFocus && _.setFocusWithoutReload(`#${elementId}`, 'a');
  };

  return (
    <section className="LeftNav">
      <div className="sc-legal-toc" role="complementary">
        <ul>
          {drugSectionList &&
            drugSectionList.map((item, index) => {
              switch (index) {
                case 0:
                  value = item.includes('&')
                    ? item.replace(' & ', '-').toLowerCase()
                    : item.replace('/', '-').toLowerCase();
                  break;
                case 1:
                case 2:
                  value = item.replace(' ', '-').toLowerCase();
                  break;
                case 3:
                  value = item.replace(' & ', '-').toLowerCase();
                  break;
                default:
                  value = item.toLowerCase();
                  break;
              }
              return (
                <li key={index}>
                  <a href={`/prescription/${seoName}#${value}`}>{item}</a>
                </li>
              );
            })}

          {whatIsIndex && (
            <li>
              <a
                href={isFromDosage ? `/prescription/${seoName}/what-is` : `#`}
                className={isFromDosage ? '' : 'what-is'}
                aria-current={!isFromDosage}
              >
                What is this drug?
              </a>
            </li>
          )}

          {sectionList &&
            sectionList.map((item, index) => {
              const val = item.replaceAll(/ /g, '-').toLowerCase();
              return (
                <li key={index} className="subList">
                  <a
                    href={`#${val}`}
                    onClick={e => handleScrollNew(e, val, false)}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        handleScrollNew(e, val, true);
                      }
                    }}
                    className={
                      visibleSection === item
                        ? 'current list-item'
                        : 'list-item'
                    }
                  >
                    {item}
                  </a>
                </li>
              );
            })}
          {(isFromDosage || dosageGuideSlug !== '') && (
            <li>
              <a
                href={
                  dosageGuideSlug !== ''
                    ? `/prescription/${dosageGuideSlug}/dosage`
                    : `#`
                }
                className={isFromDosage ? 'what-is' : ''}
                aria-current={isFromDosage}
              >
                Dosage
              </a>
            </li>
          )}
        </ul>
      </div>
    </section>
  );
};
LeftMenu.propTypes = {
  sectionList: PropTypes.array,
  visibleSection: PropTypes.string,
  isFromDosage: PropTypes.bool,
  dosageGuideSlug: PropTypes.string,
  whatIsIndex: PropTypes.number
};

LeftMenu.defaultProps = {
  sectionList: [],
  visibleSection: '',
  isFromDosage: false,
  dosageGuideSlug: '',
  whatIsIndex: true
};

export default LeftMenu;
